var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container table-chart"},[_c('div',{staticClass:"chart-head"},[_c('h2',[_vm._v(_vm._s(_vm.chartTitle))])]),_vm._v(" "),_c('div',{staticClass:"chart-main"},[_c('analytics-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }